import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import CarReducer from "./store/car/reducers/CarReducer";
import ContactReducer from "./store/contact/reducers/ContactReducer";
import { thunk } from "redux-thunk";
import "./index.scss";
import "./index.css";
import WhatsappChat from "./components/WhatsappChat";
const rootReducer = combineReducers({
  car: CarReducer,
  contact: ContactReducer,
});

const { persistStore, persistReducer } = require("redux-persist");

let devtools, store;
const isClient = typeof window !== "undefined";
if (isClient) {
  devtools = window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f;

  const storage = require("redux-persist/lib/storage").default;
  const persistConfig = {
    key: "Silver-line-auto-ltd",
    storage,
  };

  store = createStore(
    persistReducer(persistConfig, rootReducer),
    compose(applyMiddleware(thunk), devtools)
  );

  store.__PERSISTOR = persistStore(store);
} else {
  store = (rootReducer, compose(applyMiddleware(thunk)));
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      <App />
    </Provider>

    <ToastContainer />
    <WhatsappChat />

  </>
);

reportWebVitals();
